import get from 'lodash/get';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import * as basketActions from 'actions/basketActions';
import * as pageActionsV4 from 'actions/pageActionsV4';
const { basketActionsEnum } = basketActions;
const { PAGE_DATA_ACTIONS } = pageActionsV4;
const defaultState = {
    data: {}
};
export default function stickyBasket(state = defaultState, action) {
    switch (action.type) {
        case PAGE_DATA_ACTIONS.SUCCESS:
            const stickyBasketData = get(action.data, ['slots'], []).find(slot => {
                return Boolean(slot.widget &&
                    (slot.widget.type === WidgetTypeV4.STICKY_BASKET || slot.widget.type === WidgetTypeV4.STICKY_BASKET_V2));
            });
            return stickyBasketData
                ? {
                    data: get(stickyBasketData, ['widget', 'data', 'basketValue', 'value']) ||
                        get(stickyBasketData, ['widget', 'data', 'renderableComponents', '0', 'value'])
                }
                : state;
        case basketActionsEnum.ADD_TO_BASKET_SUCCESS:
        case basketActionsEnum.EDIT_ITEM_QUANTITY_IN_BASKET_SUCCESS:
            return {
                data: get(action.data, ['basketDataV2', 'data', 'basketValue', 'value']) ||
                    get(action.data, ['basketData', 'data', 'renderableComponents', '0', 'value'])
            };
        default:
            return state;
    }
}
